import { render, staticRenderFns } from "./Costos.vue?vue&type=template&id=b00c1d34&scoped=true"
import script from "./Costos.vue?vue&type=script&lang=js"
export * from "./Costos.vue?vue&type=script&lang=js"
import style0 from "./Costos.vue?vue&type=style&index=0&id=b00c1d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00c1d34",
  null
  
)

export default component.exports